export const config = {
  mvcVersion: import.meta.env['VITE_MVC_VERSION'],
  baseUrl: import.meta.env['BASE_URL'],
  guestDir: import.meta.env['VITE_GUEST_DIR'],
  labelsDir: import.meta.env['VITE_LABELS_DIR'],
  appLogo: import.meta.env['VITE_APP_LOGO'],
  b2cLogo: import.meta.env['VITE_B2C_LOGO'],
  abtest: import.meta.env['VITE_ABTEST'],
  paypalEnabled: JSON.parse(import.meta.env['VITE_PAYPAL_ENABLED'] || false),
  helpdeskEnabled: JSON.parse(import.meta.env['VITE_HELPDESK_ENABLED'] || false),
  languagesEnabled: JSON.parse(import.meta.env['VITE_LANGUAGES_ENABLED'] || false),
  forgotSmsEnabled: JSON.parse(import.meta.env['VITE_FORGOTSMS_ENABLED'] || false),
};

export enum STORAGE_KEY {
  USER = 'user',
  LANGUAGE = 'language',
  B2C_STATE = 'b2c_State',
  B2C_USER = 'b2c_User',
}

export const imgsPath = process.env.NODE_ENV === 'development' ? '/' : `/mvc51.578/${config.guestDir}/`;
export const labelsPath = `/mvc51.578/${config.guestDir}/${config.labelsDir}/{{lng}}/{{ns}}.json`;
